<template>
  <khrc-navbar/>
  <clinical-research-component />
</template>

<script>
import ClinicalResearchComponent from "@/components/ClinicalResearchComponent.vue";
import KhrcNavbar from "@/components/KhrcNavbar.vue";
export default {
  components: {
    KhrcNavbar,
    ClinicalResearchComponent,
  },
};
</script>

<style></style>
